module.exports = __webpack_public_path__ + "assets/img/Summary-item-head.16571d7c.png";